import React from 'react';
import RichText from './RichText';
import './SeoArticle.css';

// A readable article at the end of a page: headings and paragraphs that explain the page's topic in full, for
// shoppers who want the detail and for search engines. Content lives in src/seo/seoContent.js.
// In a paragraph, [label](url) makes a link and **text** bold (RichText).

export default function SeoArticle({ article }) {
  if (!article) return null;
  return (
    <section className="seo-article" aria-labelledby={article.id}>
      <div className="container seo-article-inner">
        <h2 id={article.id}>{article.title}</h2>
        {article.lead && <p className="seo-article-lead"><RichText text={article.lead} /></p>}
        {article.sections.map((s) => (
          <div key={s.h} className="seo-article-part">
            <h3>{s.h}</h3>
            {s.p.map((p, i) => <p key={i}><RichText text={p} /></p>)}
          </div>
        ))}
      </div>
    </section>
  );
}
